import styled from '@emotion/styled';

import ColumnInRowCard from '../../../components/Card/ColumnInRowCard';
import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
import { SeamlessLogisticServiceData } from './SeamlessLogisticServiceData';
import ComponentHeader from '../../../components/ComponentHeader/ComponentHeader';

const SeamlessLogisticService = () => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.1,
  });

  return (
    <Container className='intersection-animate'>
      <ComponentHeader text="Our Offerings" />
      <CardRow>
        {SeamlessLogisticServiceData.map((data, index) => (
          <ColumnInRowCard
            key={index}
            count={index + 1}
            imageName={data.imageName}
            header={data.header}
            description={data.description}
          />
        ))}
      </CardRow>
    </Container>
  );
};

export default SeamlessLogisticService;

const Container = styled.div`
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  gap: 40px;

  &.animate {
    --ydist: 100%;

    & > * {
      animation-duration: 0.3s;
      animation-delay: 0.3s;
      animation-timing-function: ease-out;
      animation-fill-mode: backwards;
    }

    & > *:first-of-type {
      animation-name: header-translate, text-opacity;
      animation-delay: 0.5s;
    }

    & > *:last-of-type {
      --ydist: 50%;
      animation-name: header-translate;
    }

    @keyframes header-translate {
      from {
        transform: translateY(var(--ydist));
      }
      to {
        transform: 0;
      }
    }

    @keyframes text-opacity {
      from {
        opacity: 0;
      }
      50% {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }

  @media (max-width: 884px) {
    align-items: center;
    padding-bottom: 55px;
  }
`;

const CardRow = styled.div`
width: 100%;
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr 1fr;
  place-items: center
  overflow: hidden;

  @media (max-width: 884px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;


